
    <div class="box">
      <div class="content">
        <div class="head">
          
          <svg *ngIf="type === 'success'" width="30" height="30" viewBox="0 0 24 19" version="1.1">
            <title>Line</title>
            <desc>Created with Sketch.</desc>
            <defs></defs>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linejoin="round">
              <g id="Artboard" transform="translate(0.000000, -3.000000)" stroke-width="3" stroke="#FFFFFF">
                <polyline id="Line" points="1 12.7985128 9.6 20 23 4"></polyline>
              </g>
            </g>
          </svg>

          <svg *ngIf="type === 'failure'" width="30" height="30" viewBox="0 0 24 24" version="1.1">
            <title>fail icon</title>
            <desc>Created with Sketch.</desc>
            <defs>
              <circle id="path-1" cx="10" cy="10" r="10"></circle>
            </defs>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linejoin="round">
              <g id="Artboard-2">
                <g id="fail-icon" transform="translate(2.000000, 2.000000)">
                  <g id="Oval-4">
                    <use stroke="#BF3939" stroke-width="2" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#path-1"></use>
                    <use stroke="#FFFFFF" stroke-width="3" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#path-1"></use>
                  </g>
                  <path d="M3.62825513,3.62825513 L17.7272727,17.7272727" id="Line" stroke="#FFFFFF" stroke-width="3"></path>
                </g>
              </g>
            </g>
          </svg>
          
        </div>
        
        <strong>
          <ng-content></ng-content>
        </strong>
      </div>
    </div>
  